import { createSlice } from "@reduxjs/toolkit";
import { fetchFieldEngineer } from "./thunk";

interface FieldEngineerState {
  FieldEngineerList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FieldEngineerState = {
  FieldEngineerList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const FieldEngineerStateSlice = createSlice({
  name: "FieldEngineerState",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchFieldEngineer.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFieldEngineer.fulfilled, (state, action) => {
      state.loading = false;
      state.FieldEngineerList = action.payload.data;
      state.rowCount = action.payload.rowCount;
    })

      .addCase(fetchFieldEngineer.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch FieldEngineerList Log";
      });
  },
});

export default FieldEngineerStateSlice.reducer;
